// import "../vendor/prettyEmbed";

$(document).ready(function() {
  const teamsMobilenavItems = $('#teamsPageNavCollapse').children('.dropdown-item');
  const dropdownItems = $('#teamsNavCollapse').children('.dropdown-item');

  $('#teamsNavCollapse').children('.dropdown-item').on('click', (el) => {
    Array.from(dropdownItems).forEach((element, index) => {
      element.classList.remove('active','show')
      $('#teams-nav-toggle').click();
      $('#teams-nav-toggle')[0].children[0].innerHTML = el.target.id.replace('-tab', '');
    })
  })

  $('#teamsPageNavCollapse').children('.dropdown-item').on('click', (el) => {
    Array.from(dropdownItems).forEach((element, index) => {
      element.classList.remove('active','show')
      $('#teams-nav-toggle').click();
      $('#teams-nav-toggle')[0].children[0].innerHTML = el.target.id.replace('-tab', '');
    })
  })

  $(function() {
    $('.teams-plus-minus-toggle').on('click', function() {
      $(this).toggleClass('more-opened');
      $(this).find('.plus-minus-toggle').toggleClass('collapsed more-opened');
    });
    $('.teams-plus-minus-toggle').on('click', function() {
      $(this).toggleClass('more-opened');
      $(this).find('.plus-minus-toggle').toggleClass('collapsed more-opened');
    });
  });

  $(function() {
    const members = $('#managementTabsContent').children('.tab-pane')
    members.each(function(index) {
      if(index !== 0) {
        $(this).removeClass('show')
      } else {
        $(this).addClass('show')
      }
    })
  });
  $(function() {
    const members = $('#managementTabsContentMobile').children('.tab-pane')
    members.each(function(index) {
      if(index !== 0) {
        $(this).removeClass('show')
      } else {
        $(this).addClass('show')
      }
    })
  });

  if ($('.team_video').length) {
    $('.team_video').get().forEach((entry, index) => {
      handleVideo(entry);
    })
  }

  function handleVideo(vid) {
    if(vid) {
      vid.addEventListener('ended', function() {
        vid.pause();
        vidFade();
      }); 
  
      let overlay = vid.previousElementSibling;

      vid.addEventListener("click", function() {
        if (vid.paused) {
          vid.play();
          vid.muted = false;
          vid.closest('div').classList.remove('paused')
          vid.classList.remove("stopfade");
        } else {
          vid.pause();
          vid.closest('div').classList.add('paused')
          vid.classList.add("stopfade");
        }
      })

      overlay.addEventListener("click", function() {
        if (vid.paused) {
          vid.play();
          vid.muted = false;
          vid.closest('div').classList.remove('paused')
          vid.classList.remove("stopfade");
        } else {
          vid.pause();
          vid.closest('div').classList.add('paused')
          vid.classList.add("stopfade");
        }
      })

    }
  }

})
